import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InsolesSelectFilterComponent} from './insoles-select-filter.component';
import {SelectFilterModule} from '../../../../../../components/common/select-filter/select-filter.module';
import {
    MultipleSelectFilterModule
} from '../../../../../core/component/multiple-select-filter/multiple-select-filter.module';

@NgModule({
    imports: [
        CommonModule,
        MultipleSelectFilterModule,
        SelectFilterModule,
    ],
    declarations: [
        InsolesSelectFilterComponent
    ],
    exports: [
        InsolesSelectFilterComponent
    ]
})
export class InsolesSelectFilterModule {}
